<span class="simple-confirm-snackbar">
  {{ message | translate }}
</span>
